import React, { useState, useEffect, useMemo } from "react";
import { Icon, Tooltip } from "antd";
import { useIntl } from "react-intl";

import ExternalLink from "../../app/generic/externalLink";
import { ReactComponent as Truck } from "../../icons/truck.svg";
import { ReactComponent as Cancel } from "../../icons/cancel.svg";
import { ReactComponent as Check } from "../../icons/checkmark.svg";
import { ReactComponent as Meeting } from "../../icons/meeting-point.svg";

import "./consignmentStateIcon.css";

function getStateIcon(state, intl) {
  switch (state) {
    case "SE":
      return {
        icon: Meeting,
        message: intl.formatMessage({
          id: "consignment.state.pickup",
          defaultMessage: "Zásilka čeká na svoz od odesílatele",
        }),
      };
    case "TR":
      return {
        icon: Truck,
        message: intl.formatMessage({
          id: "consignment.state.delivery",
          defaultMessage: "Zásilka je přepravována k příjemci",
        }),
      };
    case "ND":
      return {
        icon: Cancel,
        message: intl.formatMessage({
          id: "consignment.state.return",
          defaultMessage: "Zásilka nebyla doručena",
        }),
      };
    case "CA":
      return {
        icon: Cancel,
        message: intl.formatMessage({
          id: "consignment.state.cancelled",
          defaultMessage: "Zásilka byla stornována",
        }),
      };
    default:
      return {
        icon: Check,
        message: intl.formatMessage({
          id: "consignment.state.delivered",
          defaultMessage: "Zásilka byla úspěšně doručena",
        }),
      };
  }
}

const ConsignmentStateIcon = ({ consignmentState, proofOfDeliveryUrl }) => {
  const intl = useIntl();
  const [data, setData] = useState();
  useEffect(() => {
    setData(getStateIcon(consignmentState, intl));
  }, [intl, consignmentState]);

  const icon = useMemo(
    () =>
      data ? (
        <Tooltip title={data.message}>
          <Icon className="consignment-state-icon" component={data.icon} />
        </Tooltip>
      ) : null,
    [data]
  );

  return proofOfDeliveryUrl ? (
    <ExternalLink
      content={icon}
      href={proofOfDeliveryUrl}
      id="consignment.pod.show"
      defaultMessage="Kliknutím zobrazíte POD zásilky"
    />
  ) : (
    icon
  );
};

export default ConsignmentStateIcon;
